import { Theme, createStyles } from '@material-ui/core'
export const searchBarStyle = (theme: Theme) =>
  createStyles({
    searchInput: {
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: theme.shape.borderRadius,
      padding: `0 ${theme.spacing.unit}px`,
      backgroundColor: "#fff",
      height: "44px",
    },
    tabsContainer2: {
      margin: "5px 0 0 0",
      padding: "20px 20px 0 20px",
      borderRadius: "5px",
      position: "relative",
      "& label": {
        fontSize: 20,
        lineHeight: "22px",
        color: "#333333",
      },
    },
  });